import { render } from "./FormTips.vue?vue&type=template&id=a0d39b98"
import script from "./FormTips.vue?vue&type=script&lang=js"
export * from "./FormTips.vue?vue&type=script&lang=js"

import "./FormTips.vue?vue&type=style&index=0&id=a0d39b98&lang=scss"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__